export class TeamInviteModel {
  constructor(data) {
    this.data = data;
  }
  static fromDTO(dto) {
    return new TeamInviteModel(dto);
  }
  inviteId() {
    return this.data.inviteId;
  }
  businessId() {
    return this.data.businessId;
  }
  businessName() {
    return this.data.businessName;
  }
  isServiceProvider() {
    return this.data.isServiceProvider;
  }
}